import { render } from "./EditTypeExamen.vue?vue&type=template&id=0c7c3b9c&scoped=true"
import script from "./EditTypeExamen.vue?vue&type=script&lang=js"
export * from "./EditTypeExamen.vue?vue&type=script&lang=js"

import "./EditTypeExamen.vue?vue&type=style&index=0&id=0c7c3b9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7c3b9c"]])

export default __exports__